/**
 * Created by Joker on 2017/11/15.
 */
import Vue from 'vue'
import Vuex from 'vuex'


Vue.use(Vuex);
import customer from './modules/customer'
import employee from './modules/employee'
import remind from './modules/remind'
import task from './modules/task'
const store = new Vuex.Store({
  state: {
    id:3,
    recruitScrollY:0,
    search:{
      isSearch:false,
      searchOrder:'created_at',
      searchSubjectType:'subject',
      searchStatus:'',
      searchLabels:'',
      searchKeyword:'',
      searchStartTime:'',
      searchEndTime:'',

      searchChannels:[],
      searchCustomerTags:[],
      searchSubjects:[],
      searchEmployees:[],
    }
  },
  getters: {
    recruitScrollY:state => state.recruitScrollY
  },
  mutations: {
    changeRecruitScrollY(state,recruitScrollY) {
      state.recruitScrollY = recruitScrollY
    }
  },
  actions: {

  },
  modules: {
    customer,
    employee,
    remind,
    task,
  }
});
export default store



// WEBPACK FOOTER //
// ./src/store/index.js